import { request } from '../request';

const uploadApi = {
  /**
   * 上传文件至阿里云oss
   */
  preUpload(fileName: string) {
    return request<PreUploadResponse>({
      path: '/pad/common/v1/oss/preUpload',
      method: 'POST',
      query: { fileName, expireDay: -1 },
    });
  },
};

export default uploadApi;
